const dispatch = require("../../store.js").dispatch;
const Server = require("../../Server.js");

const SmartBonusActions = require("../../actions/metadata/SmartBonusActions.js");

const SmartBonusActionCreators = {
    SelectTarget(currentMonth) {

        console.log(currentMonth);

        dispatch({
            type: SmartBonusActions.TargetSelected,
            month: currentMonth
        });
    }
};

module.exports = SmartBonusActionCreators;


// WEBPACK FOOTER //
// ./src/actionCreators/metadata/SmartBonusActionCreators.js